import styled from "styled-components";
import { Tabs, Space, Tooltip } from "antd";
import { useEffect, useState } from "react";

import Iphone from "../../../assets/img/iphone-xs.png";
// import { ReactComponent as Refresh } from "../../../assets/img/icons/refresh.svg";
// import { ReactComponent as EditIcon } from "../../../assets/img/icons/Edit.svg";
import SmallButton from "../../Content/Shared/SmallButton";
import { RootState } from "../../../store/index";
import { useSelector } from "react-redux";
import { updateTextPreview } from "../../Design/action";
import { getQueryEmailId } from "../../EmailBrowser/utils";
import Refresh from "../../../assets/img/icons/refresh.svg";
import NoPreviewIcon from "../../../assets/img/icons/NoPreviewIcon.svg";
import { ASSET_TYPE } from "../../../constants/index";
// import Skeleton from "src/components/Design/Shared/Skeleton";
import Skeleton from "../../Design/Shared/Skeleton";
const RefreshTooltip = <span>Refresh</span>;

const { TabPane } = Tabs;

type PreviewProps = {
  emailId: number;
  campaignId: number;
  assetType?: string;
  goBack?: () => void;
};
const PreviewEmailAutomation: React.FC<PreviewProps> = ({ emailId, campaignId, assetType, goBack }) => {
  // const preview_html = useSelector((state: RootState) => state.automation.emailPreviews.loading);
  const loading = useSelector((state: RootState) => state.automation.emailPreviews.loading);
  const previewsData = useSelector((state: RootState) => state.automation.emailPreviews.data);
  const previewsTextFetchSuccess = useSelector((state: RootState) => state.automation.emailPreviews.textFetchSuccess);
  const [previewHtml, setPreviewHtml] = useState("");
  const [previewText, setPreviewText] = useState("");
  const [toggleEdit, setToggleEdit] = useState(false);
  // const [loader, setLoader] = useState(true);
  const [textPreviewValue, setTextPreviewValue] = useState('');
  const updateText = () => {
    updateTextPreview(getQueryEmailId(), textPreviewValue);
  };

  useEffect(() => {
    setTextPreviewValue(textPreviewValue);
  }, [textPreviewValue]);

  useEffect(() => {
    let html = previewsData[emailId] && previewsData[emailId].preview_html;
    let text = previewsData[emailId] && previewsData[emailId].preview_text;
    if (html) {
      setPreviewHtml(html);
    }
    if (text) {
      setPreviewText(text);
      setTextPreviewValue(text);
    }
  }, [loading, previewsData]);

  useEffect(() => {
    let previewsDataDetail = previewsData[emailId];
    let text = previewsDataDetail?.preview_text;
    if (text !== "" && text !== undefined && previewText === "") {
      setPreviewText(text);
      setTextPreviewValue(text);
    }
  }, [previewsTextFetchSuccess])

  const iframeOnLoad = () => {
    document.querySelector(".preview-frame").contentWindow.document.head.innerHTML =
      document.querySelector(".preview-frame").contentWindow.document.head.innerHTML +
      "<style>body, html{scrollbar-width: thin; scrollbar-color: #001760 #efefef;} body::-webkit-scrollbar, html::-webkit-scrollbar  { width: 5px; height: 5px; border-radius: 5px;} body::-webkit-scrollbar-track, html::-webkit-scrollbar-track {background: #fff; margin-top: 10px; margin-bottom: 15px;} body::-webkit-scrollbar-thumb, html::-webkit-scrollbar-thumb  {background: #001760;} body::-webkit-scrollbar-thumb:hover, html::-webkit-scrollbar-thumb:hover {background: #555;} body{min-height:100vh;} body .es-wrapper-color{min-height:100vh;background-color:#f9f8f6; }</style>";
    document.querySelector(".preview-frame-mobile").contentWindow.document.head.innerHTML =
      document.querySelector(".preview-frame-mobile").contentWindow.document.head.innerHTML +
      "<style>body, html{scrollbar-width: thin; scrollbar-color: #001760 #efefef;} body::-webkit-scrollbar, html::-webkit-scrollbar  { width: 5px; height: 5px; border-radius: 5px;} body::-webkit-scrollbar-track, html::-webkit-scrollbar-track {background: #fff; margin-top: 10px; margin-bottom: 15px;} body::-webkit-scrollbar-thumb, html::-webkit-scrollbar-thumb  {background: #001760;} body::-webkit-scrollbar-thumb:hover, html::-webkit-scrollbar-thumb:hover {background: #555;} body{min-height:100vh;} body .es-wrapper-color{min-height:100vh;background-color:#f9f8f6; }</style>";
  };

  const NoPreview = (
    <div className='no-preview-window'>
      <div>
        <img src={NoPreviewIcon} alt="No Preview" />
        <h2>Preview not available</h2>
        <SmallButton onClick={() => goBack && goBack()} title={"Go Back"} style={{ borderRadius: '8px' }} />
      </div>
    </div>
  )

  return (
    <>
      <Wrapper>
        <Tabs className="preview-tabs-class" type="card" tabBarStyle={{ display: 'flex', alignItems: 'center', flex: 'none', width: 'auto', position: 'relative' }}>
          <TabPane tab="HTML Email" key="1" className="desktop-preview">
            {!loading && (previewHtml === '' || previewHtml === 'null') ? (
              NoPreview
            ) : (
              <div className="preview-row d-flex" style={{ height: "calc(100% - 10px)" }}>
                <div className="iframe-wrapper" style={{ width: "calc(100% - 520px)" }}>
                  <div className="loader-wrapper"><Skeleton loading={true} /></div>
                  {/* {!loading && previewHtml === '' ? <div className='no-preview-window'>
                  <img src={NoPreviewIcon} alt="No Preview" />
                </div> : null} */}
                  <iframe
                    // srcDoc={preview_html}
                    title="PreviewHTMLIframeWeb"
                    srcDoc={previewHtml}
                    className="preview-frame"
                    width="100%"
                    frameBorder="0"
                    onLoad={iframeOnLoad}
                  ></iframe>
                </div>
                <div className="flex-shrink-1 mobile-size">
                  <div className="mobile-frame height-media">
                    <div className="inner-mobile">
                      <div className="loader-wrapper"><Skeleton loading={true} /></div>
                      <iframe
                        title="PreviewHTMLIframeMobile"
                        // srcDoc={preview_html}
                        srcDoc={previewHtml}
                        // id="previewFrameMobile"
                        className="preview-frame-mobile"
                        width="100%"
                        frameBorder="0"
                        onLoad={iframeOnLoad}
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </TabPane>
          <TabPane tab="Text Email" key="3">
            {!loading && previewText === '' ? (
              NoPreview
            ) : (
              <div className="text-container">
                {assetType === ASSET_TYPE.HYBRID && (
                  <Space
                    align="end"
                    size="large"
                    className="mb-2 w-100 text-email-icons"
                    style={{ justifyContent: "flex-end", paddingRight: "8px" }}
                  >
                    {assetType === ASSET_TYPE.HYBRID && !toggleEdit && (
                      <Tooltip placement="top" title={RefreshTooltip}>
                        <img src={Refresh} alt="refresh" style={{ cursor: "pointer" }} onClick={refreshText} />
                      </Tooltip>
                    )}
                    { /** 
                   * ! hiding edit functionality on preview
                   * */}
                    {/* {assetType === ASSET_TYPE.HYBRID && (
                    <Tooltip placement="top" title={EditTooltip}>
                      <img
                        src={EditIcon}
                        alt="edit"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          setToggleEdit(!toggleEdit);
                        }}
                      />
                    </Tooltip>
                  )} */}
                  </Space>
                )}

                <textarea
                  name="edit-text"
                  id="modal_preview_body_text1"
                  className="text-edit-area text-dark scrollable"
                  readOnly={!toggleEdit}
                  onChange={(e) => setTextPreviewValue(e.currentTarget.value)}
                  value={previewText}
                >
                  {/* {textPreviewValue} */}
                </textarea>
                {toggleEdit && (
                  <Space
                    align="end"
                    className="mt-2 w-100"
                    style={{ justifyContent: "flex-end", paddingRight: "8px" }}
                  >
                    <SmallButton
                      title="CANCEL"
                      outline="outline"
                      onClick={(e: any) => {
                        setTextPreviewValue(previewText);
                        setToggleEdit(false);
                      }}
                    />
                    <SmallButton title="UPDATE" onClick={updateText} />
                  </Space>
                )}
              </div>
            )}
          </TabPane>
        </Tabs>
      </Wrapper>
    </>
  );
};

PreviewEmailAutomation.defaultProps = {
  goBack: () => { }
};

export default PreviewEmailAutomation;

const Wrapper = styled.div`
  height: calc(100vh - 30px);
  .ant-tabs.preview-tabs-class {
    height: 100%;
      .ant-tabs-nav {
        &::before {
          display: none;
      }
       .ant-tabs-nav {
         .ant-tabs-nav-list {
          transform: translate(-50%, 0px) !important;
          left: 50% !important;
          .ant-tabs-tab {
            margin-left: 25px;
            padding: 8px 20px;
            background-color: #ffffff;
            border: 1px solid #dadada;
            color: #7e7e7e !important;
            font-size: 16px;
            font-weight: 500;
            font-family: "robotomedium" !important;
            margin-left: 25px;
            border-radius: 8px;
            @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
              padding: 8px 12px;
              font-size: 12px;
              line-height: 14px;
              border-radius: 6px;
            }
            + .ant-tabs-tab {
              margin-left: 15px;
            }
            &.ant-tabs-tab-active {
              background-color: #def6e6 !important;
              color: rgb(9, 164, 58) !important;
            }
          }
          
        }
      }
    }
    .ant-tabs-content-holder {
      border-left: 1px solid #b5c3d4;
      height: 100%;
      padding-top: 15px;
      .ant-tabs-content {
        height: 100%;
        .ant-tabs-tabpane {
          height: 100%;
          .no-preview-window{
              display: flex;
              justify-content: center;
              align-items: center;
              height: 100%;
              div {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                  h2 {
                    font-family: 'robotomedium';
                    font-size: 20px;
                    color: #424B50;
                    font-weight: 500;
                    margin-top: 40px;
                    margin-bottom: 15px;
                  }
              }
            }
          &.desktop-preview {
            @media all and (max-width: 1170px) {
              transform: scale(0.8, 0.8);
              min-width: 630px;
              transform-origin: 0 0;
              width: 125%;
              height: 125%;
              overflow: hidden;
            }
          }
          .iframe-wrapper{
            position:relative;
            .loader-wrapper{
              position: absolute;
              top:0;
              left:50%;
              z-index:0;
              transform: translate(-50%, 0);
            }
            iframe.preview-frame{
              position:relative;
              z-index:1;
            }
          }
          iframe.preview-frame,
          iframe.preview-frame-v2 {
            height: 100%;
          }
          .mobile-size {
            height: 100%;
            min-width: 520px;
            box-sizing: border-box;
            .mobile-frame {
              background-image: url(${Iphone});
              background-repeat: no-repeat;
              background-size: 100% 100%;
              height: 100%;
              max-height: 731px;
              width: 375px;
              padding: 50px 26px 45px 26px;
              box-sizing: border-box;
              display: block;
              margin: auto;
              box-sizing: border-box;
              &.height-media {
                @media all and (max-height: 800px) {
                  /* width: 320px;
                  padding: 35px 26px 30px 22px; */
                }
              }
              .inner-mobile {
                width: 100%;
                height: 100%;
                display: block;
                box-sizing: border-box;
                overflow: hidden;
                min-width: 320px;
                position:relative;
                .loader-wrapper{
                  position:absolute;
                  top:0;
                  left:0;
                  z-index:0;
                  max-width:100%;
                  .sk-container{
                    margin-top: 0 !important;
                    max-width:100%;
                    *{
                      max-width:100%;
                    }
                  }
                }
                iframe {
                  border: none;
                  width: 100%;
                  height: 100%;
                  min-width: 320px;
                  position:relative;
                  z-index:1;
                }
              }
            }
          }
          .text-container{
            height: 100%;
          }
          .text-edit-area {
            height: 100%;
            min-height: calc(100vh - 280px);
            border-radius: 7px;
            background-color: #ffffff;
            box-shadow: 0 3px 7px 0 rgba(96, 105, 125, 0.15);
            padding: 40px;
            color: #3c4663 !important;
            font-size: 14px;

            letter-spacing: 0;
            line-height: 19px;
            width: 100%;
            resize: none;
            border: none;
            margin-left: 10px;
            width: calc(100% - 15px);
          }
          .text-email-icons {
            svg {
              g,
              path {
                fill: #93a4ba;
              }
            }
          }
        }
      }
    }
  }
`;
